import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ClientesList from '../components/clientes/ClientesList';
import ClienteDetails from '../components/clientes/ClienteDetails';
import Button from '../components/ui/Button';
const ClientesPage = () => {
    const { clienteId } = useParams();
    const navigate = useNavigate();
    const [selectedClienteId, setSelectedClienteId] = useState(clienteId ? parseInt(clienteId) : null);
    const handleClienteSelect = (clienteId) => {
        setSelectedClienteId(clienteId);
        navigate(`/clientes/${clienteId}`);
    };
    const handleBackToList = () => {
        setSelectedClienteId(null);
        navigate('/clientes');
    };
    return (_jsx("div", { className: "min-h-screen bg-gray-50", children: _jsx("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8", children: selectedClienteId ? (_jsxs("div", { className: "space-y-6", children: [_jsx("div", { className: "flex items-center space-x-4", children: _jsx(Button, { variant: "ghost", size: "sm", leftIcon: _jsx(ArrowLeft, { className: "h-4 w-4" }), onClick: handleBackToList, children: "Voltar \u00E0 Lista" }) }), _jsx(ClienteDetails, { clienteId: selectedClienteId, onEdit: () => {
                            // Refresh page after edit
                            window.location.reload();
                        } })] })) : (_jsx(ClientesList, { onClienteSelect: (cliente) => handleClienteSelect(cliente.id) })) }) }));
};
export default ClientesPage;
